import script from "./DocumentGenerateDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentGenerateDialog.vue?vue&type=script&setup=true&lang=js"

import "./DocumentGenerateDialog.vue?vue&type=style&index=0&id=608e5300&lang=scss"

const __exports__ = script;

export default __exports__